document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('.js-to-top')) {
    const toTop = document.querySelector('.js-to-top');
    toTop.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    })
  }
  if (document.querySelector(".mobile-toggle-menu")) {
    document
      .querySelector(".mobile-toggle-menu")
      .addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector(".sitemap").classList.toggle("hide");
      });
  }
  AOS.init();
  document
    .querySelectorAll(".sub-menu-group-title__title ")
    .forEach((subMenu) => {
      subMenu.addEventListener("mouseover", (e) => {
        var id = subMenu.dataset.id;
        document
          .querySelectorAll(".sub-menu-group-title__title")
          .forEach((x) => x.classList.remove("active"));
        document
          .querySelectorAll(".sub-menu-group-content__item")
          .forEach((x) => x.classList.remove("active"));
        subMenu.classList.add("active");
        document
          .querySelector('.sub-menu-group-content__item[data-id="' + id + '"]')
          ?.classList.add("active");
      });
    });
  document.addEventListener("scroll", () => {
    if (window.scrollY == 0 && window.innerWidth >= 1200 && (window.template == "page.audi-edition" || window.template == "index" || window.template == "page.800serieslandingpage" || window.template == "collection.landing-promotion-earlyaccessblackfriday")) {
      document.querySelector("header").classList.add("transparent");
    } else {
      document.querySelector("header").classList.remove("transparent");
    }
    if (window.template == "page.audi-edition") {
      let scrollEnterIntro = false;
      let scrollEnterHero = false;
      let scrollEnterCar = false;
      let scrollEnterComparison = false;
      let introSectionsCount = document.querySelectorAll('intro-product').length
      let firstIntroSection = document.querySelector('intro-product')
      let lastIntroSection = document.querySelectorAll('intro-product')[introSectionsCount - 1];
      if (firstIntroSection && lastIntroSection) {
        scrollEnterIntro = lastIntroSection.getBoundingClientRect().bottom + 200 > window.innerHeight && firstIntroSection.getBoundingClientRect().top < 0;
      }
      if (document.querySelector('.audi-hero')) {
        scrollEnterHero = Math.abs(document.querySelector('.audi-hero').getBoundingClientRect().top) < document.querySelector('.audi-hero').offsetHeight;
      }
      if (document.querySelector('audi-car')) {
        scrollEnterCar = document.querySelector('audi-car').getBoundingClientRect().bottom + 200 > window.innerHeight && document.querySelector('audi-car').getBoundingClientRect().top < 0;
      }
      if (document.querySelector('comparison-table')) {
        scrollEnterComparison = document.querySelector('comparison-table').getBoundingClientRect().bottom + 800 > window.innerHeight && document.querySelector('comparison-table').getBoundingClientRect().top < 0;
      }
      if ((scrollEnterComparison || scrollEnterCar || scrollEnterIntro || scrollEnterHero) && window.scrollY != 0) {
        document.querySelector('header').style.opacity = 0
      } else {
        document.querySelector('header').removeAttribute('style')
      }
    }
    if (window.scrollY >= 1300) {
      document.querySelector('.to-top').style.display = 'block'
    } else {
      document.querySelector('.to-top').style.display = 'none'
    }
  });
});
class AudiCar extends HTMLElement {
  constructor() {
    super();
    this.road = this.querySelector(".road");
    this.carImage = this.querySelector(".car-image");
    this.carHeight = window.outerWidth < 990 ? 486 : 990;
    this.paddingTop = 128;
    this.height = this.offsetHeight;
  }
  connectedCallback() {
  }
  animation() {
    gsap.registerPlugin(ScrollTrigger);

    gsap.to(this.carImage, {
      y: this.offsetHeight - this.carImage.offsetHeight - 240, // Ô tô di chuyển xuống
      ease: "none",
      scrollTrigger: {
        trigger: this,
        start: "top center",
        end: "bottom center",
        scrub: true, // Mượt theo cuộn
        toggleActions: "play none reverse none",
      },
      duration: 2,
    });
  }
}
customElements.define("audi-car", AudiCar);

class IntroProduct extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.thumbs = this.querySelector(".product-thumbs");
    this.mainImage = this.querySelector(".main-image");
    this.productImages = this.querySelector('.product-images')
  }
  connectedCallback() {
    var thumbsSwiper = new Swiper(this.thumbs, {
      slidesPerView: "auto",
      spaceBetween: 16,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    var swiper = new Swiper(this.mainImage, {
      slidesPerView: "auto",
      thumbs: {
        swiper: thumbsSwiper,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
    window.addEventListener('scroll', this.sticky.bind(this))
  }
  sticky() {
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > this.lastScrollTop) {
        // downscroll code
        if (Math.abs(this.productImages.getBoundingClientRect().top) <= 50 && this.productImages.getBoundingClientRect().top > 0) {
          this.productImages.scrollIntoView({ behavior: "smooth" })
        }
    } else if (st < this.lastScrollTop) {
        // upscroll code
    } // else was horizontal scroll
    this.lastScrollTop = st <= 0 ? 0 : st;
  }
}
customElements.define("intro-product", IntroProduct);

class ComparisonTable extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.container = this.querySelector('.comparison-container')
    this.table = this.querySelector('.comparison-table')
    this.paddingTop = parseFloat(window.getComputedStyle(this.container, null).getPropertyValue('padding-top').replace('px', ''))
  }
  connectedCallback() {
    window.addEventListener('scroll', this.sticky.bind(this))
  }
  sticky() {
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > this.lastScrollTop) {
        // downscroll code
        if (Math.abs(this.table.getBoundingClientRect().top) <= this.paddingTop && this.table.getBoundingClientRect().top > 0) {
          this.table.scrollIntoView({ behavior: "smooth" })
        }
    } else if (st < this.lastScrollTop) {
        // upscroll code
    } // else was horizontal scroll
    this.lastScrollTop = st <= 0 ? 0 : st;
  }
}
customElements.define("comparison-table", ComparisonTable);

class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.options = this.querySelectorAll(".product-option");
    this.pendingRequestUrl;
    this.upgradeToggle = this.querySelector(".upgrade-toggle");
    this.addOptionBtns = this.querySelectorAll(".add-option-to-cart");
  }
  connectedCallback() {
    this.options.forEach((option) => {
      var inputs = option.querySelectorAll("input");
      inputs.forEach((input) => {
        input.addEventListener("change", this.changeVariant.bind(this));
      });
      option.querySelectorAll('.option-value').forEach(value => {
        value.addEventListener('click', this.chooseOption.bind(this))
      })
    });
    // if(this.upgradeToggle){
    //     this.upgradeToggle.addEventListener(
    //       "click",
    //       this.openUpgradeOptions.bind(this)
    //     );
    // }
    this.addOptionBtns.forEach(btn => {
      btn.addEventListener("click", this.addOptionToCart.bind(this))
    });
  }
  chooseOption(e) {
    var target = e.currentTarget;
    target.querySelector('input').checked = true;
    target.querySelector('input').dispatchEvent(new Event('change'))
  }
  changeVariant(e) {
    const valuesId = [];
    this
      .querySelectorAll('.product-option input[type="radio"]:checked')
      .forEach((input) => {
        valuesId.push(input.dataset.id);
      });
    const productUrl = this.dataset.url;
    const sectionId = this.dataset.sectionId;
    const requestUrl = `${window.location.origin
      }${productUrl}?section_id=${sectionId}&option_values=${valuesId.join(",")}`;

    document.querySelector("product-info").dispatchEvent(
      new CustomEvent("change:variant", {
        detail: {
          requestUrl: requestUrl,
          targetId: sectionId,
          productUrl: `${window.location.origin}${productUrl}`
        },
      })
    );
  }
  openUpgradeOptions(e) {
    this.classList.toggle("open-upgrade-option");
  }
  addOptionToCart(e) {
    e.target.setAttribute("disabled", true);
    e.target.innerHTML = "Adding to Cart";
    let data = {
      items: [
        {
          id: e.target.dataset.variant,
          quantity: 1,
        },
      ],
    };
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        e.target.removeAttribute("disabled");
        e.target.innerHTML = "Add to Cart";
        window.location.href = "/cart";
      })
      .catch((error) => {
        e.target.removeAttribute("disabled");
        e.target.innerHTML = "Add to Cart";
        console.error("Error:", error);
      });
  }
}
customElements.define("variant-selector", VariantSelector);

class SignaturesAnimation extends HTMLElement {
  constructor() {
    super();
    this.lastScrollTop = 0;
    this.space = this.querySelector('.signature-item').offsetWidth;
    this.next = 2;
    this.gap = 16;
    this.direction = 'to-right';
    this.oldIndex = 1;
    this.moveTo = this.space * (this.next - 1) + this.gap * (this.next - 1)
    this.selectedItem = 1;
  }
  connectedCallback() {
    var swiper = new Swiper(
      this.querySelector(".signatures-container.signatures-container-sp"),
      {
        slidesPerView: 1,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        parallax: true
      }
    );
    const self = this
    swiper.on('slideChange', function (swiper) {
      var index = swiper.realIndex + 1
      console.log(index)
      self.querySelectorAll('.signatures-backgrounds .signature-background').forEach(x => x.style.opacity = 0)
      self.querySelector('.signatures-backgrounds .signature-background[data-index="'+index+'"]').style.opacity = 1;
    });
    // if(window.innerWidth < 990){
    //   var backgroundSwiper = new Swiper(
    //     this.querySelector(".signatures-backgrounds-sp"),
    //     {
    //       slidesPerView: 1,
    //       loop: true,
    //       autoplay: {
    //         delay: 3500,
    //       },
    //       parallax: true
    //     }
    //   );
    // }
    document.addEventListener('scroll', this.sticky.bind(this))
    setTimeout(() => {
      this.querySelector(".backdrop-filter").style.height = this.querySelector('.signatures-items').offsetHeight + 'px'
      this.querySelector(".backdrop-filter").style.top = window.getComputedStyle(this.querySelector('.signatures-items')).marginTop
      this.querySelector(".backdrop-filter").style.width = this.querySelector('.signature-item').offsetWidth + 'px'
    },1000)
    if (window.innerWidth >= 990) {
      this.querySelector('.signatures-items').addEventListener('mousemove', this.hover.bind(this))
      this.querySelectorAll('.signatures-items .signature-item .swiper-button-prev').forEach(prev => {
        prev.addEventListener('click', this.prevFilter.bind(this))
      })
      this.querySelectorAll('.signatures-items .signature-item .swiper-button-next').forEach(next => {
        next.addEventListener('click', this.nextFilter.bind(this))
      })
    }
  }
  prevFilter(e){
    var index = parseInt(e.target.closest('.signature-item').dataset.index);
    this.oldIndex = index;
    this.selectedItem = index - 1
    this.moveTo = this.space * (this.selectedItem - 1) + this.gap * (this.selectedItem - 1)
    this.gsapAnimation(".backdrop-filter")
  }
  nextFilter(e){
    var index = parseInt(e.target.closest('.signature-item').dataset.index);
    this.oldIndex = index;
    this.selectedItem = index + 1
    this.moveTo = this.space * (this.selectedItem - 1) + this.gap * (this.selectedItem - 1)
    this.gsapAnimation(".backdrop-filter")
  }
  sticky() {
    var st = window.pageYOffset || document.documentElement.scrollTop; // Credits: "https://github.com/qeremy/so/blob/master/so.dom.js#L426"
    if (st > this.lastScrollTop) {
        // downscroll code
        if (Math.abs(this.querySelector('.signatures-animation').getBoundingClientRect().top) <= 50 && this.querySelector('.signatures-animation').getBoundingClientRect().top > 0) {
          this.querySelector('.signatures-animation').scrollIntoView({ behavior: "smooth" })
          document.querySelector('header').style.opacity = 0;
        }
    } else if (st < this.lastScrollTop) {
        // upscroll code
    } // else was horizontal scroll
    this.lastScrollTop = st <= 0 ? 0 : st;
  }
  hover(e) {
    this.querySelectorAll('.signature-item').forEach(item => {
      var rect = item.getBoundingClientRect();
      if (e.pageX <= rect.right && e.pageX >= rect.left) {
        if (this.selectedItem != item.dataset.index) {
          this.oldIndex = this.selectedItem;
          this.selectedItem = item.dataset.index
          this.moveTo = this.space * (this.selectedItem - 1) + this.gap * (this.selectedItem - 1)
          this.gsapAnimation(".backdrop-filter")
        }

      }
    })
  }
  gsapAnimation(trigger) {
    var self = this;
    gsap.to(trigger, {
      x: self.moveTo,
      duration: 1,
      ease: "power2.inOut",
      onStart: () => {
        gsap.to('.signature-background[data-index="' + self.oldIndex + '"]', {
          duration: 0.5,
          opacity: 0,
        });
        gsap.to('.signature-background[data-index="' + self.selectedItem + '"]', {
          duration: 0.5,
          opacity: 1,
        });
      },
      onComplete: function () {
        // self.oldIndex = self.next;
        // self.next = self.next == 4 ? 1 : self.next + 1;
        // self.direction = self.next == 1 ? 'to-left': 'to-right';
        // self.moveTo = self.space * (self.next - 1) + self.gap * (self.next - 1)
        // setTimeout(()=>{
        //   self.gsapAnimation(trigger)
        // },1000)
      },
      onUpdate: function () {
        let mask = self.querySelector(".backdrop-filter").getBoundingClientRect();

        self.querySelectorAll(".signature-item").forEach(section => {
          let sec = section.getBoundingClientRect();
          let sectionWidth = section.offsetWidth;

          if (self.direction == 'to-right') {
            section.style.clipPath = `inset(0 ${mask.right >= sec.right ? '0' : sectionWidth - (mask.right - sec.left) + 'px'} 0 ${mask.left >= sec.right ? '100%' : mask.left - sec.left + 'px'})`;
          }
          if (self.direction == 'to-left') {
            section.style.clipPath = `inset(0 ${mask.right <= sec.left ? '100%' : sec.right - mask.right + 'px'} 0 ${mask.right <= sec.left ? '100%' : sectionWidth - (sec.right - mask.left) + 'px'})`;
          }
        });
      }
    });
  }
}
customElements.define("signatures-animation", SignaturesAnimation);
class MediaReviews extends HTMLElement{
  constructor(){
    super();
  }
  connectedCallback(){
    var swiper = new Swiper(this.querySelector('.media-reviews-image'), {
      slidesPerView: 3,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 40,
        },
        990: {
          slidesPerView: 6,
          spaceBetween: 64,
        },
      },
    })
    var swiper2 = new Swiper(this.querySelector('.media-reviews-image-text'), {
      slidesPerView: 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        425: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 16,
        }
      },
    })
  }
}
customElements.define('media-reviews',MediaReviews)